export function panelNumber(value: number, suffix = "", digits = 0): string {
  if (!Number.isFinite(value)) return "n/a";
  return `${Number(value).toFixed(digits)}${suffix}`;
}

export function signedPanelNumber(value: number, suffix = "", digits = 0): string {
  if (!Number.isFinite(value)) return "n/a";
  const sign = value > 0 ? "+" : "";
  return `${sign}${Number(value).toFixed(digits)}${suffix}`;
}

export function compactRange(min: number, max: number, unit = "", digits = 0): string {
  if (!Number.isFinite(min) || !Number.isFinite(max)) return "";
  const low = Number(min).toFixed(digits);
  const high = Number(max).toFixed(digits);
  return `${low}-${high}${unit}`;
}

export function compactSigned(value: number, unit = "", digits = 0): string {
  if (!Number.isFinite(value)) return "";
  const rounded = Number(value).toFixed(digits);
  return `${value > 0 ? "+" : ""}${rounded}${unit}`;
}
